import { Form, Select } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

const { Option } = Select;

export default function UDFSelect({
  options,
  mode = "single",
  title = "Title",
  isFormItem = true,
  className,
  placeholder = "",
  formItemName = "",
  required = false,
  params = {},
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const renderField = () => (
    <Select
      showSearch
      {...params}
      allowClear
      optionFilterProp="label"
      placeholder={placeholder}
      className={className}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      style={style}
      disabled={disabled}
    >
      {options?.map((item) => {
        return (
          <Option key={item.id} value={item.id}>
            {item.value}
          </Option>
        );
      })}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        rules={required && [{ required: true, message: `Select ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
